// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Loader_Loader__zrmc1","dotFlashing":"Loader_dotFlashing__5Z3h2"};